<template>
    <div>
        <div v-if="hasParent" class="helpdesk-options__back">
            <common-button type="link" icon="back" size="tiny" :isSubmittable="false" @click="goBack()"></common-button>
        </div>
        <div v-for="option in selectedOptions" :key="option.name" class="helpdesk-options__option" @click="selectOption(option)">
            <div class="helpdesk-options__option--icon">
                <common-icon :name="optionIconName(option)" size="huge"></common-icon>
            </div>
            <div>
                <p>{{ option.name }}</p>
                <p v-if="!option.value" class="helpdesk-options__option--text">
                    {{ $t('components.helpdesk.helpdesk.options.chose') }}
                </p>
            </div>
        </div>
        <common-video-player-modal
            v-if="isVideoModalOpen"
            :videoSrc="videoSrc"
            @close="closeVideoModal()"
        ></common-video-player-modal>
    </div>
</template>

<script>
    import cloneDeep from 'lodash.clonedeep'

    export default {
        props: {
            options: { type: Array, required: true },
        },

        data() {
            return {
                selectedOptions: [],
                videoSrc: undefined,
                isVideoModalOpen: false,
                hasParent: false,
            }
        },

        methods: {
            setOptions(options) {
                this.selectedOptions = cloneDeep(options)
            },
            closeVideoModal() {
                this.isVideoModalOpen = false
            },
            openVideoModal() {
                this.isVideoModalOpen = true
            },
            selectOption(option) {
                if (option.value) {
                    this.videoSrc = option.value
                    this.openVideoModal()
                } else {
                    this.setOptions(option.childs)
                    this.hasParent = true
                }
            },
            optionIconName(option) {
                return option.value ? 'play' : 'dots'
            },
            goBack() {
                this.setOptions(this.options)
                this.hasParent = false
            },
        },

        mounted() {
            this.setOptions(this.options)
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .helpdesk-options {
        &__back {
            margin: 10px 20px;
        }
        &__option {
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: 20px 18px;
            @include breakpoint(laptop) {
                @media (max-height: 680px) {
                    padding: 12px 18px;
                }
            }
            @include breakpoint(smartphone-large) {
                padding: 12px 18px;
            }

            &--text {
                color: $color--txt-base-3;
                font-size: 14px;
            }

            &--icon {
                color: white;
                height: 50px;
                width: 50px;
                min-width: 50px;
                line-height: 50px;
                background-color: $color--accent-3;
                text-align: center;
                border-radius: 50%;
                margin-right: 20px;
            }

            &:hover {
                background: whitesmoke;
            }
        }
    }
</style>
